import { create } from '@thoughtspot/logger';
import _ from 'lodash';
import { getDefaultPropsFromDefaultValues, } from './client-state-type';
import { BackgroundFormatTypes, Operators, } from './types/prism';
const logger = create('client-state-util');
export const DEFAULT_CONDITIONAL_METRIC = {
    __typename: 'ConditionalMetric',
    operator: null,
    fontProperties: null,
    gradientBackgroundAttrs: null,
    rangeValues: null,
    value: null,
    backgroundFormatType: BackgroundFormatTypes.Solid,
    plotAsBand: null,
    solidBackgroundAttrs: {
        __typename: 'SolidBackgroundAttrs',
        color: null,
    },
};
export function getUpdatedConditionalFormatting(col, defaultConditionalMetric = DEFAULT_CONDITIONAL_METRIC) {
    const metricDefinition = col.metricDefinition;
    if (metricDefinition && metricDefinition.row) {
        const conditionalFormatting = {
            __typename: 'ConditionalFormatting',
            rows: [],
        };
        _.forEach(metricDefinition.row, columnMetric => {
            var _a;
            let conditionalMetric = getDefaultPropsFromDefaultValues(defaultConditionalMetric, {
                plotAsBand: (_a = columnMetric.plotAsBand) !== null && _a !== void 0 ? _a : null,
                solidBackgroundAttrs: {
                    __typename: 'SolidBackgroundAttrs',
                    color: columnMetric.color || null,
                },
            });
            const rangeValue = columnMetric.range;
            if (rangeValue &&
                _.isNumber(rangeValue.max) &&
                _.isNumber(rangeValue.min)) {
                conditionalMetric = {
                    ...conditionalMetric,
                    operator: Operators.IsBetween,
                    rangeValues: {
                        __typename: 'Range',
                        max: rangeValue.max,
                        min: rangeValue.min,
                    },
                };
            }
            else if (rangeValue && _.isNumber(rangeValue.max)) {
                conditionalMetric = {
                    ...conditionalMetric,
                    operator: Operators.LessThan,
                    value: rangeValue.max.toString(),
                };
            }
            else if (rangeValue && _.isNumber(rangeValue.min)) {
                conditionalMetric = {
                    ...conditionalMetric,
                    operator: Operators.GreaterThanEqualTo,
                    value: rangeValue.min.toString(),
                };
            }
            else {
                logger.error('Unable to parse legacy client state, ' +
                    'will lead to corrupted data [legacy metric, new metric]', columnMetric, conditionalMetric);
            }
            if (!_.isNil(conditionalMetric.operator)) {
                conditionalFormatting.rows.push(conditionalMetric);
            }
        });
        return conditionalFormatting;
    }
    return null;
}
export function recoverConditionalFormattingForColumns(vizProps) {
    var _a;
    const updatedVizProps = _.cloneDeep(vizProps);
    if (((_a = updatedVizProps === null || updatedVizProps === void 0 ? void 0 : updatedVizProps.columnProperties) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        _.forEach(updatedVizProps.columnProperties, (colMap) => {
            var _a, _b, _c;
            if ((_a = colMap.columnProperty) === null || _a === void 0 ? void 0 : _a.conditionalFormatting) {
                _.forEach((_c = (_b = colMap.columnProperty) === null || _b === void 0 ? void 0 : _b.conditionalFormatting) === null || _c === void 0 ? void 0 : _c.rows, metric => {
                    if (metric.rangeValues &&
                        metric.operator === Operators.IsBetween) {
                        if (_.isNil(metric.rangeValues.min) &&
                            Number.isFinite(metric.rangeValues.max)) {
                            metric.operator = Operators.LessThan;
                            metric.value = _.toString(metric.rangeValues.max);
                            metric.rangeValues = null;
                        }
                        else if (_.isNil(metric.rangeValues.max) &&
                            Number.isFinite(metric.rangeValues.min)) {
                            metric.operator =
                                Operators.GreaterThanEqualTo;
                            metric.value = _.toString(metric.rangeValues.min);
                            metric.rangeValues = null;
                        }
                    }
                    else if (!metric.value &&
                        metric.rangeValues &&
                        Number.isFinite(metric.rangeValues.max) &&
                        Number.isFinite(metric.rangeValues.min)) {
                        metric.operator = Operators.IsBetween;
                    }
                });
            }
        });
    }
    return updatedVizProps;
}
//# sourceMappingURL=conditional-formatting-upgrade-util.js.map